import { useSelector } from "react-redux";
import ServerWakeUp from '../components/ServerWakeUp';

// Stranice koje bez servera ne mogu ništa prikazati čekaju da se server pokrene
function RequireServer({ children }) {
    const serverStatus = useSelector((state) => state.serverStore.status);

    if (serverStatus !== 'ready') {
        return <ServerWakeUp />;
    }

    return children;
}

export default RequireServer;
